import React from 'react';
import { FiExternalLink } from "react-icons/fi";
import work1 from '../../Asset/work-1.png'

const Work = ({ work }) => {
    return (
        <div className="work" data-aos="zoom-in-down" data-aos-duration="1500">
            <img src={work1} alt="First Work" />
            <div className="layer">
                <h3>{work.title}</h3>
                <p>{work.description}</p>
                <a href={work.link}><FiExternalLink size="30px" /></a>
            </div>
        </div>
    );
};

export default Work;